import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import useMulticotizadorSelector from "./useMulticotizadorSelector";
import { setCurrentPoliza, clearCurrentPoliza } from "../actions";
import DetalleCotizacionTable from "~business/cotizaciones/detalleCotizacionTable/DetalleCotizacionTable";
import useGetCotizaciones from "../useGetCotizaciones";
import { PolizaCotizada } from "../types";

const useReduxSelector = () =>
  useMulticotizadorSelector((state) => ({
    detalleCotizacion: state.detalleCotizacion,
  }));

const ListadoCotizacionesStep = () => {
  const dispatch = useDispatch();
  const { detalleCotizacion } = useReduxSelector();

  useEffect(() => {
    dispatch(clearCurrentPoliza());
    //eslint-disable-next-line
  }, [dispatch]);

  const handleOpen = (poliza: PolizaCotizada) => {
    dispatch(
      setCurrentPoliza({ value: poliza, open: true, contratada: false })
    );
  };

  const isPending = useGetCotizaciones();

  return (
    <DetalleCotizacionTable
      isPending={isPending}
      onClick={handleOpen}
      detalleCotizacion={detalleCotizacion}
    />
  );
};

export default ListadoCotizacionesStep;
